<template>
    <div class="field">
        <label
            v-if="label"
            class="label is-small"
        >
            {{ labelText }}
        </label>
        <div class="control has-icons-left flatpickr">
            <input
                v-bind="$attrs"
                ref="picker"
                class="input is-small"
                :class="inputClasses"
                readonly
                data-input
                @keyup.delete="reset"
            />
            <span class="icon is-left is-small">
                <i class="fas fa-calendar-alt"></i>
            </span>
        </div>
        <p
            v-for="error in errors"
            :key="error"
            class="help is-danger"
        >
            {{ error }}
        </p>
    </div>
</template>

<script>
import flatpickr from "flatpickr";

import Field from "./Field";

export default {
    name: "T3DateField",
    extends: Field,
    props: {
        modelValue: {
            type: [Array, String],
            default: () => [],
        },
        format: {
            type: String,
            default: "d/m/Y",
        },
        minValue: {
            type: String,
            default: undefined,
        },
        maxValue: {
            type: String,
            default: undefined,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        singleString: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["update:model-value"],
    watch: {
        minValue() {
            this.createPicker();
        },
        maxValue() {
            this.createPicker();
        },
        readonly() {
            this.createPicker();
        },
        modelValue(newval) {
            if (newval && newval !== "|") {
                if (this.singleString) {
                    this.lPicker.setDate(newval.split("|").map((x) => this.$parseDate(x, this.format)));
                } else {
                    this.lPicker.setDate([
                        this.$parseDate(newval[0], this.format),
                        this.$parseDate(newval[1], this.format),
                    ]);
                }
            } else {
                this.lPicker.setDate(null);
            }
        },
    },
    mounted() {
        this.createPicker();
    },
    methods: {
        createPicker() {
            if (this.lPicker) {
                delete this.lPicker;
            }

            this.lPicker = flatpickr(this.$refs.picker, {
                allowInput: false,
                clickOpens: !this.readonly,
                dateFormat: this.format,
                minDate: this.minValue !== undefined ? this.$parseDate(this.minValue, this.format) : undefined,
                maxDate: this.maxValue !== undefined ? this.$parseDate(this.maxValue, this.format) : undefined,
                locale: {
                    firstDayOfWeek: 1,
                },
                mode: "range",
                onChange: this.onChange,
            });
            if (this.modelValue) {
                if (this.singleString) {
                    this.lPicker.setDate(this.modelValue.split("|").map((x) => this.$parseDate(x, this.format)));
                } else {
                    this.lPicker.setDate([
                        this.$parseDate(this.modelValue[0], this.format),
                        this.$parseDate(this.modelValue[1], this.format),
                    ]);
                }
            }
        },
        reset() {
            this.lPicker.setDate(null);
            this.$emit("update:model-value", null);
        },
        onChange(selectedDates) {
            if (this.singleString) {
                this.$emit(
                    "update:model-value",
                    [
                        this.$dateToString(selectedDates[0], this.format),
                        this.$dateToString(selectedDates[1], this.format),
                    ].join("|"),
                );
            } else {
                this.$emit("update:model-value", [
                    this.$dateToString(selectedDates[0], this.format),
                    this.$dateToString(selectedDates[1], this.format),
                ]);
            }
        },
    },
};
</script>

<style scoped>
input {
    min-width: 12rem;
    max-width: 12rem;
}
</style>
